import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useScreen from 'hooks/useScreen';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
const ProductListingQuickshipFilter = () => {
  const $ = _c(8);
  const {
    filters,
    toggleBooleanFilter
  } = useProductListingPageContext();
  let t0;
  if ($[0] !== filters) {
    t0 = filters.find(_temp);
    $[0] = filters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const quickshipFilter = t0;
  const {
    isMobile,
    isMobileOrTablet
  } = useScreen();
  if (!quickshipFilter) {
    return null;
  }
  const t1 = isMobileOrTablet && !isMobile;
  let t2;
  if ($[2] !== toggleBooleanFilter) {
    t2 = () => {
      toggleBooleanFilter("quickship");
    };
    $[2] = toggleBooleanFilter;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== quickshipFilter.isActive || $[5] !== t1 || $[6] !== t2) {
    t3 = <QuickShipFilter isChecked={quickshipFilter.isActive} isTablet={t1} minHeight={false} onChange={t2} showLabelOnMobile={true} withLocation={true} />;
    $[4] = quickshipFilter.isActive;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default ProductListingQuickshipFilter;
function _temp(t0) {
  const {
    id
  } = t0;
  return id === "quickship";
}